import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=8acd67ea&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,HepLogo: require('/vercel/path0/components/general/HepLogo.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default,InfoIcon: require('/vercel/path0/components/icons/InfoIcon.vue').default,ProductAuthors: require('/vercel/path0/components/product/ProductAuthors.vue').default,QuantityInput: require('/vercel/path0/components/cart/QuantityInput.vue').default,ProductPrice: require('/vercel/path0/components/product/ProductPrice.vue').default})
